import { render, staticRenderFns } from "./RejectVersion.vue?vue&type=template&id=71941d6d&scoped=true"
import script from "./RejectVersion.vue?vue&type=script&lang=js"
export * from "./RejectVersion.vue?vue&type=script&lang=js"
import style0 from "./RejectVersion.vue?vue&type=style&index=0&id=71941d6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71941d6d",
  null
  
)

export default component.exports